import { CheckboxItem } from "./checkbox-item.model";
import { RequestFileLoad } from "./request-file-load.model";
import { RefundRequestInvoiceItem } from "./request-refund-invoice-item.model";
import { RequestState } from "./request-state.model";

export class RefundRequestHisto{

    constructor(
        public idReembolsoSolicitudHisto? : string, // idRequestRefundHisto
        public idReembolsoSolicitud? : string, // idRequestRefund
        public fechaRegistro? : string, // fechahora
        public idCiudadRes? : string, // idResidentialCity
        public ciudadRes? : string, // residentialCity
        public direccionResidencia? : string, // residentialAddress
        public codBanco? : string, // idBank
        public nombreBanco? : string, // nameBank
        public cuentaBancaria? : string, // idAccountBank
        public titular? : string, // nameAccountBank
        public tipoCuenta? : string, // typeAccountBank
        public benIdTipoIdentificacion? : string, // benTipoIdentificacion4
        public benNumeroIdentificacion? : string, // benDocumentoIdentidad
        public benNombre? : string, // benNombre
        public cantidadReembolsos? : string, // numberRefunds
        public razonReembolso? : string, // textReasonRefund
        public listaReembolsoEstados? : CheckboxItem[], // idTipoReembolsoSelected
        public listaFactura? : RefundRequestInvoiceItem[], // listaFacturas
        public estadoSolicitud? : RequestState, // stateRequest
        public montoFacturas? : number
    ){

    }
}




// WEBPACK FOOTER //
// /app/src/app/shared/models/request-refund-histo.model.ts